var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var IWA_DOMAIN = 'iwa';
var NAVIGATE_EVENT = 'navigate';
var BACK_EVENT = 'navigate_back';
/** Trigger a native navigation to a new route.
 * @param route The route to navigate to
 * @param options Navigation options
 */
export var navigate = function (route, options) {
    if (options === void 0) { options = {}; }
    if (options.tab && !options.app) {
        throw new Error('Invalid navigation. The target webapp must be provided when navigating across tabs');
    }
    return {
        domain: IWA_DOMAIN,
        eventType: NAVIGATE_EVENT,
        data: __assign({ route: route, webapp_id: options.app, tab_id: options.tab, transition: options.replace ? 'replace' : 'push' }, (options.additionalData || {})),
    };
};
/** Navigate back one route, or until a specific route is found in the back stack
 * @param route_id The id of a route to find in the back stack
 * @param app The id of a webapp to find route_id in.
 *
 * @description
 * If this is called with no options the native app will navigate back one step.
 *
 * If a route_id is provided the native app will attempt to find a matching route
 * from the webapp.json of the current webapp or of the webapp with id specified
 * in the app parameter.
 */
export var navigateBack = function (route_id, app) { return ({
    domain: IWA_DOMAIN,
    eventType: BACK_EVENT,
    data: {
        route_id: route_id,
        webapp_id: app,
    },
}); };
export var setReady = function () { return ({
    domain: 'iwa',
    eventType: 'set_ready',
    data: {},
}); };
//# sourceMappingURL=iwa.js.map